import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Config } from '@leverege/plugin';
import { Content, Text, Button, IconUtil, Pane } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './TemporaryUserForbiddenScreen.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  ns
} = I18N.ns('molten.screens.temporaryUser.ForbiddenScreen');
/*
  examples of custom error messages/titles you could put in translation-en

  "temporaryUser" : {
    "expired": {
      "title": "Expired",
      "message": "Your temporary access has expired."
    },
    "revoked": {
      "title": "Revoked",
      "message": "Your temporary access has been revoked."
    },
    "invalidUsernameAccessCode": {
      "title": "Invalid Username Or Access Code",
      "message": "The username or access code provided is invalid."
    }
  }
*/

function tWithCode(code) {
  if (code == null) {
    return t;
  }
  return (...args) => {
    const {
      t: subT
    } = ns(code);
    return subT(...args, t(...args));
  };
}
function TemporaryUserForbiddenScreen(props) {
  const {
    title,
    msg,
    url,
    button,
    image,
    error
  } = props;
  const {
    code
  } = error || {};
  const codeT = tWithCode(code);
  let mTitle = title === undefined ? Config.get('TemporaryUserForbiddenScreen', 'title', codeT('title')) : title;
  const mMsg = msg === undefined ? Config.get('TemporaryUserForbiddenScreen', 'message', codeT('message')) : msg;
  const mButton = button === undefined ? Config.get('TemporaryUserForbiddenScreen', 'button', codeT('button')) : button;
  let mUrl = url === undefined ? Config.get('TemporaryUserForbiddenScreen', 'link', () => localStorage.getItem('lastActivePage') || '/') : url;
  const mImg = image === undefined ? Config.get('TemporaryUserForbiddenScreen', 'image', 'https://molten-ui-assets.storage.googleapis.com/forbidden-temporary-user.svg') : image;
  const img = useMemo(() => {
    if (Array.isArray(mImg)) {
      return mImg[Math.floor(Math.random() * mImg.length) % mImg.length];
    }
    return mImg;
  }, [mImg]);
  if (typeof mUrl === 'function') {
    mUrl = mUrl();
  }
  if (typeof mTitle === 'string') {
    mTitle = /*#__PURE__*/_jsx(Text, {
      variant: "inactivityTitle|title",
      children: mTitle
    });
  }
  return /*#__PURE__*/_jsx(Content, {
    horizontal: true,
    variant: "editor",
    children: /*#__PURE__*/_jsx(Content.Area, {
      variant: "inactivityScreen",
      className: S.area,
      children: /*#__PURE__*/_jsxs(Pane, {
        variant: "inactivityScreenContent",
        className: S.content,
        children: [mImg && /*#__PURE__*/_jsx("div", {
          className: S.fontIcon,
          children: IconUtil.create(img)
        }), /*#__PURE__*/_jsxs("div", {
          children: [mTitle, /*#__PURE__*/_jsx(Text, {
            variant: "inactivityCaption|caption",
            children: mMsg
          }), mUrl && window?.Intercom ? /*#__PURE__*/_jsx(Button, {
            variant: "linkNoPad|link",
            className: S.continue,
            onClick: () => {
              window?.Intercom('showNewMessage');
            },
            children: mButton
          }) : null]
        })]
      })
    })
  });
}
export default connect((state, ownProps) => {
  return {};
})(TemporaryUserForbiddenScreen);